"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_persist_1 = require("redux-persist");
var storage_1 = __importDefault(require("redux-persist/lib/storage"));
var constants_1 = __importDefault(require("../../../config/constants"));
var authentication_1 = require("@pbl/pbl-react-core/lib/models/authentication");
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    authenticating: false,
    loading: false,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    account: null,
    errorMessage: '',
    XSRF_TOKEN: null,
    email: '',
    password: '',
    userData: {},
    showSuspendMessage: false,
    forgotPassSent: false,
    resendMailSent: false,
    emailAddress: '',
    playerId: undefined,
    session: undefined,
    playerRoles: [],
    isRestricted: false
};
var AuthReducer = function (state, action) {
    var _a;
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(authentication_1.LOGIN):
            return __assign(__assign({}, state), { authenticating: true });
        case (0, action_type_util_1.REQUEST)(authentication_1.GET_ACCOUNT):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(authentication_1.LOGIN):
            return __assign(__assign({}, state), { loading: false, authenticating: false, isAuthenticated: true, accessToken: action.payload.access_token, refreshToken: action.payload.refresh_token, showSuspendMessage: false });
        case (0, action_type_util_1.SUCCESS)(authentication_1.GET_ACCOUNT): {
            return __assign(__assign({}, state), { loading: false, account: action.payload });
        }
        case (0, action_type_util_1.FAILURE)(authentication_1.LOGIN):
            return __assign(__assign({}, state), { errorMessage: action.payload.message, authenticating: false, playerId: undefined, session: undefined, accessToken: null, refreshToken: null, showSuspendMessage: action.payload.payload &&
                    action.payload.payload.additionalInformation &&
                    action.payload.payload.additionalInformation.message ===
                        'error.uaaAuthentication.suspended' });
        case (0, action_type_util_1.FAILURE)(authentication_1.GET_ACCOUNT):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        case (0, action_type_util_1.SUCCESS)(authentication_1.SEND_PASSWORD_RESET_INSTRUCTIONS):
            return __assign(__assign({}, state), { forgotPassSent: true });
        case (0, action_type_util_1.SUCCESS)(authentication_1.SEND_ACCOUNT_ACTIVATION_INSTRUCTIONS):
            return __assign(__assign({}, state), { resendMailSent: true, emailAddress: action.payload });
        case authentication_1.RESET_AUTHENTICATION:
            return __assign({}, INITIAL_STATE);
        case authentication_1.CLEAR_AUTHENTICATION_ERROR:
            return __assign(__assign({}, state), { errorMessage: '', showSuspendMessage: false });
        case (0, action_type_util_1.SUCCESS)(authentication_1.GET_USER):
            return __assign(__assign({}, state), { userData: action.payload });
        case (0, action_type_util_1.REQUEST)('authentication/LOGOUT'):
            return __assign(__assign({}, state), { loading: true, errorMessage: '' });
        case (0, action_type_util_1.SUCCESS)('authentication/LOGOUT'):
            return __assign(__assign({}, state), { loading: false, isAuthenticated: false, errorMessage: '' });
        case 'RESET_RESEND_EMAIL_ACTIVATION':
            return __assign(__assign({}, state), { resendMailSent: false });
        case (0, action_type_util_1.REQUEST)('authentication/SESSION_CHECK'):
            return __assign(__assign({}, state), { authenticating: true });
        case (0, action_type_util_1.SUCCESS)('authentication/SESSION_CHECK'):
        case (0, action_type_util_1.FAILURE)('authentication/SESSION_CHECK'):
            return __assign(__assign({}, state), { authenticating: false, isAuthenticated: action.payload });
        case (0, action_type_util_1.SUCCESS)('authentication/SESSION_PERMISSIONS'):
            return __assign(__assign({}, state), { playerRoles: action.payload, isRestricted: Array.isArray(action.payload)
                    ? !((_a = action.payload) === null || _a === void 0 ? void 0 : _a.some(function (item) { return item === 'ROLE_PLAYER'; })) &&
                        constants_1.default.IS_RESTRICTION_ENABLED
                    : constants_1.default.IS_RESTRICTION_ENABLED });
        default:
            return __assign({}, state);
    }
};
var persistConfig = {
    key: 'authentication',
    storage: storage_1.default,
    whitelist: [
        'autheticating',
        'loading',
        'errorMessage',
        'XSRF_TOKEN',
        'email',
        'password',
        'accessToken',
        'refreshToken',
        'account',
        'userData',
        'showSuspendMessage',
        'forgotPassSent',
        'resendMailSent',
        'playerRoles',
        'isRestricted'
    ]
};
exports.default = (0, redux_persist_1.persistReducer)(persistConfig, AuthReducer);
//# sourceMappingURL=reducers.js.map